export const productShortName = 'El Niño & Extreme Weather Risk — Professional Edition™';
export const productBrand = 'El Niño & Extreme Weather Risk';
export const productEdition = 'Professional Edition™';
export const productImage = 'https://cdn.magicpatterns.com/uploads/286kZBuQNxRfTTu2tVNKgR/MOCKUP_NINO.png';
export const productImageAlt =
  'El Niño & Extreme Weather Risk Professional Edition: six volumes covering ENSO fundamentals, global impacts, flood and drainage, heat and drought, operational continuity and emergency response, plus five bonus resources';

export const checkoutUrl = 'https://el-nino-extreme-weather-risk.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 6;
export const totalBonuses = 5;
export const bonusTotalValue = 'USD 70.00';

export const closingLines = [
  'No more confusion when reading ENSO forecasts and bulletins',
  'No more guessing how El Niño will affect your region and sector',
  'No more drainage, water and power surprises at your site',
  'No more improvised responses to floods, heat and drought',
  'No more preparing when the season has already started',
];
